import React from 'react';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import useServicesPerYearTotalChart from './hooks/useServicesPerYearTotalChart';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';

export const ServicesPerYearTotal = ({ height }) => {
    const { module } = useServicesChartsDataContext();
    const { series, subtitles } = useServicesPerYearTotalChart();

    return (
        <SimpleBars
            height={height}
            title={`Evolução ${module.sectionTitle} por Ano`}
            series={series}
            subtitles={subtitles}
            values={[]}
        />
    );
};
